import { z } from 'zod';

/**
 * Every tab an account drilldown can open on, as named by the `?accountTab=` URL param. This is the
 * vocabulary only: each layout (V1 drilldown, Flow lens, Growth Strategist lens) declares which of
 * these it offers, and a value it does not offer opens that layout's default tab.
 */
export const AccountDrilldownTabSchema = z.enum([
  'fields',
  'timeline',
  'opps',
  'signals',
  'intel',
  'workspaces',
  'hierarchy',
  'summary',
  'product-usage',
  'people',
  'open-loops',
  'delphi',
]);

export type AccountDrilldownTab = z.infer<typeof AccountDrilldownTabSchema>;
